export default __webpack_public_path__ + "static/media/tree_3.4d5199c3.png";